import { Link, usePage } from '@inertiajs/react'
import type { ReactNode } from 'react'

interface NavItemProps {
  href: string
  icon: ReactNode
  label: string
  title?: string
  onClick?: () => void
  shouldShowExpanded: boolean
  isMobileMenuOpen: boolean
  alsoMatchPaths?: string[]
}

export default function NavItem({ href, icon, label, title, onClick, shouldShowExpanded, isMobileMenuOpen, alsoMatchPaths }: NavItemProps) {
  const { url } = usePage()
  const isActive = url.startsWith(href) || (alsoMatchPaths?.some(p => url.startsWith(p)) ?? false)
  return <li>
    <Link href={href} onClick={onClick} title={!shouldShowExpanded ? (title || label) : ''}
      className={`flex items-center py-2.5 md:py-1.5 transition-colors duration-150 rounded-md ${
        shouldShowExpanded || isMobileMenuOpen ? 'mx-2 px-3' : 'w-full justify-center'
      } ${isActive ? 'text-foreground bg-accent font-medium' : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'}`}>
      <div className="w-4 h-4 flex-shrink-0">{icon}</div>
      <span className={`text-sm transition-all duration-300 ease-in-out overflow-hidden whitespace-nowrap ${
        !shouldShowExpanded && !isMobileMenuOpen ? 'w-0 opacity-0' : 'ml-3 w-auto opacity-100'
      }`}>{label}</span>
    </Link>
  </li>
}
